module.exports = __webpack_public_path__ + "img/case_1.2e6d576c.png";